// Auto-generated from content_first_playlist_output.json
// Generated at: 2025-12-16T09:53:06+00:00
// DO NOT EDIT THIS FILE DIRECTLY - regenerate using scripts/convert_content_first_to_professor_mode.rb

export function getMockData() {
  return {
  "classification": {
    "type": "Comprehensive",
    "complexity": "Intermediate",
    "key_concepts": [
      "north-south position",
      "submission finishing",
      "attack chaining"
    ]
  },
  "userContext": {
    "belt_level": "Level: White Belt | 3 Stripes",
    "experience": "Experience: 2 years, 6 months",
    "gi_preference": "Both Gi and No-Gi training",
    "game_style": "Style: Technical",
    "learning_style": "Systematic learner"
  },
  "reasoningSnippets": [
    "Building comprehensive north-south attack system",
    "Progressing from control fundamentals to advanced submissions",
    "World-class instruction from experienced practitioners",
    "Emphasis on chaining attacks and strategic transitions",
    "Practical troubleshooting for skilled opponents"
  ],
  "plan": {
    "title": "North-South Finishing System",
    "type": "comprehensive_course",
    "estimated_duration": "136 mins",
    "video_count": 19,
    "chapter_count": 4,
    "total_segment_duration_minutes": 136.8,
    "total_original_duration_minutes": 136.8,
    "plan_reasoning": [
      "This playlist is tailored to help you master fundamental aspects of the north-south position with a focus on finishing submissions, especially the north-south choke, from a beginner white belt perspective. We've selected clear, high-percentage instructional videos that emphasize proper control, mechanics, and basic transitions, incorporating insights from Marcelo Garcia and Keenan Cornelius where possible to enhance your understanding and effectiveness."
    ],
    "chapters": [
      {
        "number": 1,
        "title": "Foundations of North-South Control and Positioning",
        "description": "This chapter introduces the essential principles of establishing and maintaining dominant north-south control, focusing on balance, weight distribution, and positional retention. Understanding these fundamentals sets the groundwork for successful submission attempts and effective transitions.",
        "learning_objectives": [
          "Master foundations of north-south control and positioning",
          "Understand key mechanics and principles",
          "Develop practical application skills",
          "Troubleshoot common mistakes"
        ],
        "estimated_duration_minutes": 62.1,
        "original_duration_minutes": 62.1,
        "segment_count": 15,
        "videos": [
          {
            "position": 1,
            "id": "HW1lA2aUdiM",
            "title": "North-South Position Basics and Transitions: BJJ Fundamentals with Kris Kim (Black Belt)",
            "instructor": "Kris Kim",
            "segment_title": "North-South Control - Entry & Transitions",
            "duration_minutes": 4.4,
            "segment_duration_minutes": 2.9,
            "thumbnail_url": "https://i.ytimg.com/vi/HW1lA2aUdiM/hqdefault.jpg",
            "selection_reasoning": "This video is foundational to the chapter because it introduces the essential mechanics for achieving and stabilizing north-south control, directly addressing why students often struggle to finish from this position. Kris Kim explains how to transition into north-south from other dominant top positions, as well as crucial details for maximizing stability and minimizing risks of escape—key knowledge for any effective attack. By covering body alignment, grip options, and common mistakes, the lesson ensures learners can hold the position confidently, setting up future submission attempts. For students struggling to finish, mastering these underlying mechanics is critical: you can't finish submissions in north-south unless you can consistently achieve and maintain the position itself.",
            "segments": [
              {
                "start_time": "0:00",
                "end_time": "1:06",
                "duration_seconds": 66,
                "title": "North-South Entry",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "1:06",
                "end_time": "2:12",
                "duration_seconds": 66,
                "title": "Body Alignment",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "2:12",
                "end_time": "3:18",
                "duration_seconds": 66,
                "title": "Grip Options",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "3:18",
                "end_time": "4:24",
                "duration_seconds": 66,
                "title": "Escape Prevention",
                "reasoning": "Essential content for skill development",
                "included": true
              }
            ],
            "matched_questions": [
              0,
              2,
              3,
              5,
              7,
              8
            ],
            "question_texts": [
              "Fundamentals of north-south control and weight distribution for beginners",
              "Basic transitions from side control to north-south position with retention tips",
              "Hand and arm placement details for effective north-south submissions",
              "Simple kimura entries and finishes from north-south position",
              "Beginner mistakes when maintaining north-south pressure and how to fix them",
              "Marcelo Garcia instructional on north-south position fundamentals"
            ]
          },
          {
            "position": 2,
            "id": "i-66eFNO2eQ",
            "title": "North-South Position Retention with Hip Movement – BJJ Fundamentals by Jean Jacques Machado",
            "instructor": "Jean Jacques Machado",
            "segment_title": "North-South Control - Hip Retention",
            "duration_minutes": 0.6,
            "segment_duration_minutes": 0.4,
            "thumbnail_url": "https://i.ytimg.com/vi/i-66eFNO2eQ/hqdefault.jpg",
            "selection_reasoning": "This segment drills deeply into the critical skill of retention once you've established north-south. Jean Jacques Machado's focus on hip movement directly addresses the most common escape problems students face: opponents recovering guard or escaping due to lack of dynamic pressure. By honing proper hip rotation and countering leg recovery attempts, students learn to keep opponents trapped, maximizing their time in a dominant position to look for finishes. These concepts are essential to build before layering on submissions; unless you can prevent escapes, you'll struggle to threaten or finish from north-south, so this fits perfectly after learning how to enter and settle the top position.",
            "segments": [
              {
                "start_time": "0:00",
                "end_time": "0:09",
                "duration_seconds": 9,
                "title": "Hip Rotation Control",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "0:09",
                "end_time": "0:18",
                "duration_seconds": 9,
                "title": "Dynamic Pressure Application",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "0:18",
                "end_time": "0:27",
                "duration_seconds": 9,
                "title": "Leg Recovery Counters",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "0:27",
                "end_time": "0:36",
                "duration_seconds": 9,
                "title": "North-South Retention",
                "reasoning": "Essential content for skill development",
                "included": true
              }
            ],
            "matched_questions": [
              0,
              2,
              7,
              8
            ],
            "question_texts": [
              "Fundamentals of north-south control and weight distribution for beginners",
              "Basic transitions from side control to north-south position with retention tips",
              "Beginner mistakes when maintaining north-south pressure and how to fix them",
              "Marcelo Garcia instructional on north-south position fundamentals"
            ]
          },
          {
            "position": 3,
            "id": "rUGzYHubPc8",
            "title": "North South Position Control & Escape Strategies in BJJ – Fundamentals with Jared Welman",
            "instructor": "Jared Welman",
            "segment_title": "North-South - Control and Escapes",
            "duration_minutes": 6.0,
            "segment_duration_minutes": 4.0,
            "thumbnail_url": "https://i.ytimg.com/vi/rUGzYHubPc8/hqdefault.jpg",
            "selection_reasoning": "Covering both top and bottom perspectives, this video reinforces the chapter’s focus on controlling and navigating the north-south position. For students aiming to finish from north-south, understanding the most likely escape strategies (framing, stiff-arming, hip movement) is crucial for preemptively shutting them down. Jared Welman's combined wrestling and BJJ insights illuminate transitions into north-south and specific mechanics for applying heavy pressure to pin and expose vulnerable arms and necks—key for progressing to submissions. Simultaneously, the escapes shown educate students on what opponents will do, improving anticipatory control and retention, rounding out the learner’s foundational toolkit.",
            "segments": [
              {
                "start_time": "0:00",
                "end_time": "1:30",
                "duration_seconds": 90,
                "title": "North-South Control",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "1:30",
                "end_time": "3:00",
                "duration_seconds": 90,
                "title": "Heavy Pressure Mechanics",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "3:00",
                "end_time": "4:30",
                "duration_seconds": 90,
                "title": "Escape Frames & Hips",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "4:30",
                "end_time": "6:00",
                "duration_seconds": 90,
                "title": "Submission Setups",
                "reasoning": "Essential content for skill development",
                "included": true
              }
            ],
            "matched_questions": [
              0,
              2,
              6,
              7,
              8
            ],
            "question_texts": [
              "Fundamentals of north-south control and weight distribution for beginners",
              "Basic transitions from side control to north-south position with retention tips",
              "Breaking defensive frames and grips when attacking from north-south",
              "Beginner mistakes when maintaining north-south pressure and how to fix them",
              "Marcelo Garcia instructional on north-south position fundamentals"
            ]
          },
          {
            "position": 4,
            "id": "HSsHg3Eza9w",
            "title": "Foundational Balance, Base, and Hip Control for Beginner No-Gi Jiu-Jitsu—Chris Paines",
            "instructor": "Chris Paines",
            "segment_title": "Fundamentals - Base & Hip Control",
            "duration_minutes": 23.4,
            "segment_duration_minutes": 15.7,
            "thumbnail_url": "https://i.ytimg.com/vi/HSsHg3Eza9w/hqdefault.jpg",
            "selection_reasoning": "Mastery of body balance, base, and hip control forms the bedrock for all positional dominance in BJJ, and thus, every effective north-south attack. Chris Paines’ lesson—while not exclusively about north-south—builds this chapter’s vital base of knowledge: how to maintain your own stability, control your opponent’s hips, and prevent being swept or losing control on top. These principles carry directly into all aspects of superior north-south control: pinning, adjusting weight, and thwarting escapes. Without a solid sense of base and balance, students will find it increasingly difficult to hold north-south when seeking finishes, so the segment is indispensable to reinforce core positional skills.",
            "segments": [
              {
                "start_time": "0:00",
                "end_time": "5:51",
                "duration_seconds": 351,
                "title": "Maintaining Base",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "5:51",
                "end_time": "11:42",
                "duration_seconds": 351,
                "title": "Hip Control Techniques",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "11:42",
                "end_time": "17:33",
                "duration_seconds": 351,
                "title": "Preventing Sweeps",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "17:33",
                "end_time": "23:24",
                "duration_seconds": 351,
                "title": "Adjusting Pressure",
                "reasoning": "Essential content for skill development",
                "included": true
              }
            ],
            "matched_questions": [
              0
            ],
            "question_texts": [
              "Fundamentals of north-south control and weight distribution for beginners"
            ]
          },
          {
            "position": 5,
            "id": "UBeTMRQ1cWI",
            "title": "Maintaining Balance and Passing Guard in No-Gi BJJ: Beginner Concepts with Chris Paines",
            "instructor": "Chris Paines",
            "segment_title": "Guard Passing - Balance & Hip Control",
            "duration_minutes": 27.7,
            "segment_duration_minutes": 18.6,
            "thumbnail_url": "https://i.ytimg.com/vi/UBeTMRQ1cWI/hqdefault.jpg",
            "selection_reasoning": "This video expands on the foundational movement and control concepts essential to reaching and maintaining dominant positions like north-south. By teaching balance, base, and how to shut down opponent’s hips/legs during guard passing, Chris Paines ensures students develop proactive habits that transfer directly to their ability to both enter north-south and keep opponents pinned there. For those struggling to finish from north-south, these skills minimize scrambles and escapes—making it more likely students will hold the position long enough to attack for submissions. Placing this early in the learning progression cements the idea that submission success starts with effective top pressure and movement.",
            "segments": [
              {
                "start_time": "0:00",
                "end_time": "6:55",
                "duration_seconds": 415,
                "title": "Balance and Base",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "6:55",
                "end_time": "13:51",
                "duration_seconds": 416,
                "title": "Shutting Down Hips",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "13:51",
                "end_time": "20:46",
                "duration_seconds": 415,
                "title": "Guard Passing Control",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "20:46",
                "end_time": "27:42",
                "duration_seconds": 416,
                "title": "North-South Maintenance",
                "reasoning": "Essential content for skill development",
                "included": true
              }
            ],
            "matched_questions": [
              0
            ],
            "question_texts": [
              "Fundamentals of north-south control and weight distribution for beginners"
            ]
          }
        ]
      },
      {
        "number": 2,
        "title": "Fundamental North-South Submission Mechanics",
        "description": "Building on control, this chapter dives into the core submission mechanics from north-south, emphasizing the setup and finishing details of the north-south choke and kimura, along with key grips and arm placements. These videos focus on simple, high-percentage techniques suitable for white belts.",
        "learning_objectives": [
          "Master fundamental north-south submission mechanics",
          "Understand key mechanics and principles",
          "Develop practical application skills",
          "Troubleshoot common mistakes"
        ],
        "estimated_duration_minutes": 29.6,
        "original_duration_minutes": 29.6,
        "segment_count": 15,
        "videos": [
          {
            "position": 1,
            "id": "RkFHJHC58qc",
            "title": "Marcelo Garcia Teaches North South Choke from Top Position for BJJ Fundamentals",
            "instructor": "Marcelo Garcia",
            "segment_title": "North-South - Classic Choke Finish",
            "duration_minutes": 9.3,
            "segment_duration_minutes": 6.2,
            "thumbnail_url": "https://i.ytimg.com/vi/RkFHJHC58qc/hqdefault.jpg",
            "selection_reasoning": "This video is included because it delivers a world-class, fundamental introduction to the north-south choke, featuring clear teaching from a renowned expert, Marcelo Garcia. It breaks down the principles behind securing the choke—controlling the opponent’s arms, proper head orientation, pressure placement, and avoiding common finishing mistakes. For students struggling to finish from north-south, this systematic, bodyweight-driven approach is critical for understanding when and how to apply force safely and effectively. This serves as a foundational submission for white belts, directly matching the chapter’s focus on simple, high-percentage mechanics.",
            "segments": [
              {
                "start_time": "0:00",
                "end_time": "2:19",
                "duration_seconds": 139,
                "title": "Arm Control",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "2:19",
                "end_time": "4:39",
                "duration_seconds": 140,
                "title": "Head Positioning",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "4:39",
                "end_time": "6:58",
                "duration_seconds": 139,
                "title": "Pressure Application",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "6:58",
                "end_time": "9:18",
                "duration_seconds": 140,
                "title": "Finishing Mistakes",
                "reasoning": "Essential content for skill development",
                "included": true
              }
            ],
            "matched_questions": [
              0,
              1,
              3,
              4,
              8
            ],
            "question_texts": [
              "Fundamentals of north-south control and weight distribution for beginners",
              "Step-by-step north-south choke setup and finishing mechanics for white belts",
              "Hand and arm placement details for effective north-south submissions",
              "Troubleshooting common north-south choke problems at beginner level",
              "Marcelo Garcia instructional on north-south position fundamentals"
            ]
          },
          {
            "position": 2,
            "id": "Lhk4EZl4jjE",
            "title": "North-South Choke Instruction from North-South Position (No-Gi) with Marcelo Garcia",
            "instructor": "Marcelo Garcia",
            "segment_title": "North-South - Hand Fighting and Choke",
            "duration_minutes": 6.3,
            "segment_duration_minutes": 4.2,
            "thumbnail_url": "https://i.ytimg.com/vi/Lhk4EZl4jjE/hqdefault.jpg",
            "selection_reasoning": "This video is included to deepen the learning on the north-south choke, especially addressing scenarios where opponents defend with active hand fighting. Marcelo Garcia demonstrates how to methodically clear the arms, manipulate grips, and adjust hand connections to maintain pressure and seal off defensive escapes. This expands on the core mechanics by troubleshooting common resistance, building the student's ability to adapt mid-attack—a vital skill for reliably finishing from north-south. It fits the chapter progression by reinforcing and adding essential troubleshooting strategies to the base choke, further targeting the student’s struggles with finishing submissions.",
            "segments": [
              {
                "start_time": "0:00",
                "end_time": "1:34",
                "duration_seconds": 94,
                "title": "Clearing Opponent's Arms",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "1:34",
                "end_time": "3:09",
                "duration_seconds": 95,
                "title": "Grip Manipulation",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "3:09",
                "end_time": "4:43",
                "duration_seconds": 94,
                "title": "Adjusting Hand Connections",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "4:43",
                "end_time": "6:18",
                "duration_seconds": 95,
                "title": "Maintaining Pressure",
                "reasoning": "Essential content for skill development",
                "included": true
              }
            ],
            "matched_questions": [
              1,
              3,
              4,
              8
            ],
            "question_texts": [
              "Step-by-step north-south choke setup and finishing mechanics for white belts",
              "Hand and arm placement details for effective north-south submissions",
              "Troubleshooting common north-south choke problems at beginner level",
              "Marcelo Garcia instructional on north-south position fundamentals"
            ]
          },
          {
            "position": 3,
            "id": "VGJ88g6aqxA",
            "title": "Kimura Submission from North South Position—Step-by-Step BJJ Technique for All Levels",
            "instructor": "Unknown",
            "segment_title": "North-South - Kimura Lock Basics",
            "duration_minutes": 1.9,
            "segment_duration_minutes": 1.3,
            "thumbnail_url": "https://i.ytimg.com/vi/VGJ88g6aqxA/hqdefault.jpg",
            "selection_reasoning": "This video introduces the Kimura as a core submission option from north-south, offering a step-by-step beginner-friendly breakdown. It covers how to isolate the arm, secure tight grips, and use full-body movement to finish, including grip breaks. For students struggling to finish from north-south, learning the Kimura not only increases submission threats but also builds on positional control and transitions—essential for chaining attacks. Including this Kimura demonstration ensures the chapter covers both primary north-south submissions and gives practical solutions for finishing even when the choke may not be available.",
            "segments": [
              {
                "start_time": "0:00",
                "end_time": "0:28",
                "duration_seconds": 28,
                "title": "Arm Isolation",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "0:28",
                "end_time": "0:57",
                "duration_seconds": 29,
                "title": "Secure Grip Setup",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "0:57",
                "end_time": "1:25",
                "duration_seconds": 28,
                "title": "Full-Body Finish",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "1:25",
                "end_time": "1:54",
                "duration_seconds": 29,
                "title": "Counter Grip Breaks",
                "reasoning": "Essential content for skill development",
                "included": true
              }
            ],
            "matched_questions": [
              3,
              5,
              6,
              9
            ],
            "question_texts": [
              "Hand and arm placement details for effective north-south submissions",
              "Simple kimura entries and finishes from north-south position",
              "Breaking defensive frames and grips when attacking from north-south",
              "Connecting basic submissions from north-south to follow-up attacks"
            ]
          },
          {
            "position": 4,
            "id": "ZFwS97dmH_4",
            "title": "Kimura Submission from North/South Control – Step-by-Step BJJ Gi/No Gi Instructional",
            "instructor": "Jeremy Arel",
            "segment_title": "North-South - Kimura Setup Details",
            "duration_minutes": 5.8,
            "segment_duration_minutes": 3.9,
            "thumbnail_url": "https://i.ytimg.com/vi/ZFwS97dmH_4/hqdefault.jpg",
            "selection_reasoning": "This video is selected to provide in-depth, technical instruction on setting up and finishing the Kimura from north-south, including key details on angle changes, using leverage, and tightening the space. It focuses on the nuances of arm isolation, head and knee placement, and how to use body mechanics, rather than brute force, to break defenses and finish the submission. Placement here helps students go beyond the basics, addressing common mistakes and control issues that typically result in failed finishes. It is especially useful for learners who have the general idea but struggle with the details needed to secure consistent submissions.",
            "segments": [
              {
                "start_time": "0:00",
                "end_time": "1:27",
                "duration_seconds": 87,
                "title": "Angle Adjustments",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "1:27",
                "end_time": "2:54",
                "duration_seconds": 87,
                "title": "Arm Isolation",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "2:54",
                "end_time": "4:21",
                "duration_seconds": 87,
                "title": "Head & Knee Placement",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "4:21",
                "end_time": "5:48",
                "duration_seconds": 87,
                "title": "Leverage & Space",
                "reasoning": "Essential content for skill development",
                "included": true
              }
            ],
            "matched_questions": [
              3,
              5,
              6,
              9
            ],
            "question_texts": [
              "Hand and arm placement details for effective north-south submissions",
              "Simple kimura entries and finishes from north-south position",
              "Breaking defensive frames and grips when attacking from north-south",
              "Connecting basic submissions from north-south to follow-up attacks"
            ]
          },
          {
            "position": 5,
            "id": "i3_vevp6EP4",
            "title": "Top 3 Submission Attacks from North-South Position in BJJ – Kimura, Back Take, Choke",
            "instructor": "Stephan Kesting",
            "segment_title": "North-South - Attack Sequences Overview",
            "duration_minutes": 6.3,
            "segment_duration_minutes": 4.2,
            "thumbnail_url": "https://i.ytimg.com/vi/i3_vevp6EP4/hqdefault.jpg",
            "selection_reasoning": "This video ties together the chapter by showing how to sequence multiple high-percentage submissions (Kimura, north-south choke, and back take) from north-south, explaining how to transition when one attack fails or is defended. By covering entries, grip details, and adjustment strategies, it gives students a practical map for navigating real resistance. For learners struggling to finish, understanding how to chain attacks and switch between the choke and Kimura increases both submission rates and confidence in maintaining control. This comprehensive approach reinforces the chapter theme—mastering fundamental mechanics—and solidifies the positional knowledge needed to reliably finish from north-south.",
            "segments": [
              {
                "start_time": "0:00",
                "end_time": "1:34",
                "duration_seconds": 94,
                "title": "Kimura Entry",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "1:34",
                "end_time": "3:09",
                "duration_seconds": 95,
                "title": "North-South Choke",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "3:09",
                "end_time": "4:43",
                "duration_seconds": 94,
                "title": "Back Take Transitions",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "4:43",
                "end_time": "6:18",
                "duration_seconds": 95,
                "title": "Chaining Submissions",
                "reasoning": "Essential content for skill development",
                "included": true
              }
            ],
            "matched_questions": [
              3,
              5,
              6,
              8,
              9
            ],
            "question_texts": [
              "Hand and arm placement details for effective north-south submissions",
              "Simple kimura entries and finishes from north-south position",
              "Breaking defensive frames and grips when attacking from north-south",
              "Marcelo Garcia instructional on north-south position fundamentals",
              "Connecting basic submissions from north-south to follow-up attacks"
            ]
          }
        ]
      },
      {
        "number": 3,
        "title": "Basic Transitions, Grip Breaking, and Submission Chains",
        "description": "This chapter explores transitions from side control to north-south, grip fighting, and chaining attacks such as armbars and kimuras. It includes practical strategies to overcome common defensive frames and smoothly flow between submissions, improving your finishing rates.",
        "learning_objectives": [
          "Master basic transitions, grip breaking, and submission chains",
          "Understand key mechanics and principles",
          "Develop practical application skills",
          "Troubleshoot common mistakes"
        ],
        "estimated_duration_minutes": 29.3,
        "original_duration_minutes": 29.3,
        "segment_count": 15,
        "videos": [
          {
            "position": 1,
            "id": "ExRy6o0fbAM",
            "title": "Marcelo Garcia Teaches North South Choke and Armbar Transitions from Side Control",
            "instructor": "Marcelo Garcia",
            "segment_title": "North South - Submission Chains",
            "duration_minutes": 11.4,
            "segment_duration_minutes": 7.6,
            "thumbnail_url": "https://i.ytimg.com/vi/ExRy6o0fbAM/hqdefault.jpg",
            "selection_reasoning": "This video is foundational for the chapter because it features Marcelo Garcia detailing not just isolated submissions but the crucial transitions and leverage needed to reliably finish from north-south. It covers how to flow from side control into north-south, manage defensive frames, and chain together the north-south choke and armbars. This progression gives students practical solutions to overcome stubborn defense and maintain control, which directly addresses the learning goal of struggling to finish from north-south. Students will understand weight distribution, grip control, and how to capitalize on escapes, building a strong conceptual and technical base for chaining submissions in live grappling.",
            "segments": [
              {
                "start_time": "0:00",
                "end_time": "2:51",
                "duration_seconds": 171,
                "title": "Side Control to North-South",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "2:51",
                "end_time": "5:42",
                "duration_seconds": 171,
                "title": "Managing Defensive Frames",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "5:42",
                "end_time": "8:33",
                "duration_seconds": 171,
                "title": "Chaining North-South Choke",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "8:33",
                "end_time": "11:24",
                "duration_seconds": 171,
                "title": "Armbar Finish Techniques",
                "reasoning": "Essential content for skill development",
                "included": true
              }
            ],
            "matched_questions": [
              2,
              8
            ],
            "question_texts": [
              "Basic transitions from side control to north-south position with retention tips",
              "Marcelo Garcia instructional on north-south position fundamentals"
            ]
          },
          {
            "position": 2,
            "id": "5DoRM9hjvqQ",
            "title": "North South Choke and Armbar Escapes from Top Position – Kris Kim BJJ Instructional",
            "instructor": "Kris Kim",
            "segment_title": "North South - Grip Breaks & Attacks",
            "duration_minutes": 3.0,
            "segment_duration_minutes": 2.0,
            "thumbnail_url": "https://i.ytimg.com/vi/5DoRM9hjvqQ/hqdefault.jpg",
            "selection_reasoning": "This video is included to focus specifically on breaking strong defensive grips from the bottom—a major barrier to finishes from north-south. Kris Kim demonstrates how to use overhooks and positional shifts to dismantle body locks and arm grips, turning failed choke or Kimura attempts into submission opportunities. Teaching both choke and armbar transitions, it embodies the chapter’s theme of grip fighting and chaining submissions. This pragmatic approach gives students the tools to not only initiate attacks but adapt when the opponent locks them down, directly supporting the student's goal to increase their finish rate from north-south.",
            "segments": [
              {
                "start_time": "0:00",
                "end_time": "0:45",
                "duration_seconds": 45,
                "title": "Breaking Defensive Grips",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "0:45",
                "end_time": "1:30",
                "duration_seconds": 45,
                "title": "Overhook Control",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "1:30",
                "end_time": "2:15",
                "duration_seconds": 45,
                "title": "Positional Shifts",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "2:15",
                "end_time": "3:00",
                "duration_seconds": 45,
                "title": "Choke to Armbar Transitions",
                "reasoning": "Essential content for skill development",
                "included": true
              }
            ],
            "matched_questions": [
              3,
              5,
              6,
              9
            ],
            "question_texts": [
              "Hand and arm placement details for effective north-south submissions",
              "Simple kimura entries and finishes from north-south position",
              "Breaking defensive frames and grips when attacking from north-south",
              "Connecting basic submissions from north-south to follow-up attacks"
            ]
          },
          {
            "position": 3,
            "id": "cnfcBYYDYQY",
            "title": "North South Triple Attack: Choke & Armbar Setups from Top with Kris Kim (BJJ Purple Belts)",
            "instructor": "Kris Kim",
            "segment_title": "North South - Triple Attack Sequence",
            "duration_minutes": 2.7,
            "segment_duration_minutes": 1.8,
            "thumbnail_url": "https://i.ytimg.com/vi/cnfcBYYDYQY/hqdefault.jpg",
            "selection_reasoning": "This segment deepens the concept of chaining submissions by providing a three-pronged attack sequence: chaining two variations of the north-south choke with an armbar, all connected by effective grip breaking. It builds on earlier concepts by encouraging students to read the opponent’s defenses and seamlessly flow between attacks, rather than stalling when a finish is blocked. By illustrating both choke variations and an armbar finish, this video broadens the learner's north-south arsenal, reinforcing the pedagogical theme of submission chaining and directly serving those who struggle to get a clean finish from top position.",
            "segments": [
              {
                "start_time": "0:00",
                "end_time": "0:40",
                "duration_seconds": 40,
                "title": "North-South Choke Variations",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "0:40",
                "end_time": "1:21",
                "duration_seconds": 41,
                "title": "Effective Grip Breaking",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "1:21",
                "end_time": "2:01",
                "duration_seconds": 40,
                "title": "Transitioning to Armbar",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "2:01",
                "end_time": "2:42",
                "duration_seconds": 41,
                "title": "Chaining Submission Attacks",
                "reasoning": "Essential content for skill development",
                "included": true
              }
            ],
            "matched_questions": [
              4,
              5,
              6,
              9
            ],
            "question_texts": [
              "Troubleshooting common north-south choke problems at beginner level",
              "Simple kimura entries and finishes from north-south position",
              "Breaking defensive frames and grips when attacking from north-south",
              "Connecting basic submissions from north-south to follow-up attacks"
            ]
          },
          {
            "position": 4,
            "id": "FT6TIlcM_VY",
            "title": "Kimura to North South Choke Transition from Side Control – BJJ Setup and Finishing Details",
            "instructor": "Chewy",
            "segment_title": "Side Control - Kimura to North South Choke",
            "duration_minutes": 5.6,
            "segment_duration_minutes": 3.8,
            "thumbnail_url": "https://i.ytimg.com/vi/FT6TIlcM_VY/hqdefault.jpg",
            "selection_reasoning": "This instructional is included to teach how arm attacks from side control—namely the Kimura—can naturally lead into north-south choke opportunities. By starting with an arm attack, students learn to manipulate defensive reactions, create openings for the north-south choke, and refine finishing details such as chin control, grip variation, and pressure application. This lesson fits the chapter’s emphasis on smooth transitions and chaining submissions, giving students a versatile attack pathway. It's especially useful for coaches and learners looking to troubleshoot north-south chokes and increase their ability to finish when initial submission attempts are defended.",
            "segments": [
              {
                "start_time": "0:00",
                "end_time": "1:24",
                "duration_seconds": 84,
                "title": "Kimura Setup",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "1:24",
                "end_time": "2:48",
                "duration_seconds": 84,
                "title": "Defensive Manipulation",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "2:48",
                "end_time": "4:12",
                "duration_seconds": 84,
                "title": "North-South Entry",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "4:12",
                "end_time": "5:36",
                "duration_seconds": 84,
                "title": "Finishing Controls",
                "reasoning": "Essential content for skill development",
                "included": true
              }
            ],
            "matched_questions": [
              1,
              2,
              5,
              9
            ],
            "question_texts": [
              "Step-by-step north-south choke setup and finishing mechanics for white belts",
              "Basic transitions from side control to north-south position with retention tips",
              "Simple kimura entries and finishes from north-south position",
              "Connecting basic submissions from north-south to follow-up attacks"
            ]
          },
          {
            "position": 5,
            "id": "CGDxx6_mASo",
            "title": "No-Gi Armbar to North South Choke Transition from Side Control for BJJ (with Chewy & Adam Wilson)",
            "instructor": "Chewy",
            "segment_title": "No-Gi - Armbar to North South Choke",
            "duration_minutes": 6.6,
            "segment_duration_minutes": 4.4,
            "thumbnail_url": "https://i.ytimg.com/vi/CGDxx6_mASo/hqdefault.jpg",
            "selection_reasoning": "This video adds a no-gi specific perspective, demonstrating a real-world scenario where an opponent defends against an armbar, leading to a transition into the north-south choke. It reinforces the key learning theme of chaining submissions and adapting mid-attack when resistance is encountered. By showcasing active pressure, head and arm mechanics, and the relevance of body positioning (e.g., active toes, shoulder drive), this segment rounds out the chapter’s technical arsenal and offers direct answers to the learning goal of struggling to finish from north-south, especially in the faster, slippier environment of no-gi grappling.",
            "segments": [
              {
                "start_time": "0:00",
                "end_time": "1:39",
                "duration_seconds": 99,
                "title": "No-Gi Armbar Setup",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "1:39",
                "end_time": "3:18",
                "duration_seconds": 99,
                "title": "Defending to North-South",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "3:18",
                "end_time": "4:57",
                "duration_seconds": 99,
                "title": "Pressure and Positioning",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "4:57",
                "end_time": "6:36",
                "duration_seconds": 99,
                "title": "Chaining Submissions",
                "reasoning": "Essential content for skill development",
                "included": true
              }
            ],
            "matched_questions": [
              1,
              2
            ],
            "question_texts": [
              "Step-by-step north-south choke setup and finishing mechanics for white belts",
              "Basic transitions from side control to north-south position with retention tips"
            ]
          }
        ]
      },
      {
        "number": 4,
        "title": "Escapes, Troubleshooting, and Defensive Awareness",
        "description": "To round out your understanding, this chapter covers essential defensive strategies, escapes from north-south, and troubleshooting common problems encountered while attacking or maintaining pressure. These lessons help keep you safe on the bottom and improve your ability to maintain control on top.",
        "learning_objectives": [
          "Master escapes, troubleshooting, and defensive awareness",
          "Understand key mechanics and principles",
          "Develop practical application skills",
          "Troubleshoot common mistakes"
        ],
        "estimated_duration_minutes": 15.8,
        "original_duration_minutes": 15.8,
        "segment_count": 12,
        "videos": [
          {
            "position": 1,
            "id": "IvXlFOlSi6w",
            "title": "Defending the Inversion: North-South Control & Block by Jean Jacques Machado (BJJ Gi Training)",
            "instructor": "Jean Jacques Machado",
            "segment_title": "North-South - Inversion Prevention",
            "duration_minutes": 0.9,
            "segment_duration_minutes": 0.6,
            "thumbnail_url": "https://i.ytimg.com/vi/IvXlFOlSi6w/hqdefault.jpg",
            "selection_reasoning": "This video is included in the chapter to address a core problem faced when trying to hold and finish from north-south: the opponent's inversion escape. By teaching precise hand placement, weight distribution, and hip control, it helps students maintain top pressure and stop common escape attempts. This fits thematically with the chapter's aim of troubleshooting and strengthening both defensive and offensive aspects of north-south. For students struggling to finish, controlling escapes like the inversion is essential for setting up reliable submissions or advancing position.",
            "segments": [
              {
                "start_time": "0:00",
                "end_time": "0:13",
                "duration_seconds": 13,
                "title": "Hand Placement Control",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "0:13",
                "end_time": "0:27",
                "duration_seconds": 14,
                "title": "Weight Distribution",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "0:27",
                "end_time": "0:40",
                "duration_seconds": 13,
                "title": "Hip Control",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "0:40",
                "end_time": "0:54",
                "duration_seconds": 14,
                "title": "Countering Inversion",
                "reasoning": "Essential content for skill development",
                "included": true
              }
            ],
            "matched_questions": [
              0,
              6
            ],
            "question_texts": [
              "Fundamentals of north-south control and weight distribution for beginners",
              "Breaking defensive frames and grips when attacking from north-south"
            ]
          },
          {
            "position": 2,
            "id": "1H2P82elHcM",
            "title": "North South Escape Body Mechanics for BJJ – Key Details with Jean Jacques Machado (Gi, All Levels)",
            "instructor": "Jean Jacques Machado",
            "segment_title": "North-South - Body Mechanics Escape",
            "duration_minutes": 5.0,
            "segment_duration_minutes": 3.4,
            "thumbnail_url": "https://i.ytimg.com/vi/1H2P82elHcM/hqdefault.jpg",
            "selection_reasoning": "This lesson builds foundational movement skills for escaping north-south—key for anyone stuck on bottom and for understanding the nuances of body leverage and energy management. By focusing on creating space, staying patient, and making your opponent expend energy, it teaches both technical escapes and the strategic mindset needed to consistently get out from a tough spot. This directly supports the chapter's goal of defensive awareness and escape proficiency, especially aligning with students who have trouble finishing or holding north-south, as these details explain how the bottom player can create difficult problems for the top.",
            "segments": [
              {
                "start_time": "0:00",
                "end_time": "1:15",
                "duration_seconds": 75,
                "title": "Creating Space",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "1:15",
                "end_time": "2:30",
                "duration_seconds": 75,
                "title": "Patience and Timing",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "2:30",
                "end_time": "3:45",
                "duration_seconds": 75,
                "title": "Energy Management",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "3:45",
                "end_time": "5:00",
                "duration_seconds": 75,
                "title": "Leverage Details",
                "reasoning": "Essential content for skill development",
                "included": true
              }
            ],
            "matched_questions": [
              0,
              7,
              8
            ],
            "question_texts": [
              "Fundamentals of north-south control and weight distribution for beginners",
              "Beginner mistakes when maintaining north-south pressure and how to fix them",
              "Marcelo Garcia instructional on north-south position fundamentals"
            ]
          },
          {
            "position": 3,
            "id": "A9PAlXwclPI",
            "title": "North South Position Escapes for No-Gi BJJ: Two Effective Techniques for Beginners",
            "instructor": "Chewy",
            "segment_title": "North-South - No-Gi Core Escapes",
            "duration_minutes": 5.1,
            "segment_duration_minutes": 3.4,
            "thumbnail_url": "https://i.ytimg.com/vi/A9PAlXwclPI/hqdefault.jpg",
            "selection_reasoning": "This video is included because it presents accessible, high-percentage escapes specifically for students new to defending north-south in no-gi. Covering both the pendulum and headlock escape options, it addresses real-world scenarios where students often get stuck, including recognition of submission threats. The focus on actionable techniques and limb positioning complements the chapter’s emphasis on troubleshooting and defensive development. It’s particularly useful for understanding both sides of the position—strengthening your bottom defense while also revealing the common ways your control might break down when on top.",
            "segments": [
              {
                "start_time": "0:00",
                "end_time": "1:16",
                "duration_seconds": 76,
                "title": "Pendulum Escape",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "1:16",
                "end_time": "2:33",
                "duration_seconds": 77,
                "title": "Headlock Defense",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "2:33",
                "end_time": "3:49",
                "duration_seconds": 76,
                "title": "Submission Threats",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "3:49",
                "end_time": "5:06",
                "duration_seconds": 77,
                "title": "Limb Positioning",
                "reasoning": "Essential content for skill development",
                "included": true
              }
            ],
            "matched_questions": [
              6,
              7
            ],
            "question_texts": [
              "Breaking defensive frames and grips when attacking from north-south",
              "Beginner mistakes when maintaining north-south pressure and how to fix them"
            ]
          },
          {
            "position": 4,
            "id": "RhlG6cXmk8A",
            "title": "North South Choke Prevention and Escape from Side Control – No-Gi BJJ Instructional",
            "instructor": "Unknown",
            "segment_title": "North-South - Choke Prevention & Escape",
            "duration_minutes": 4.8,
            "segment_duration_minutes": 3.2,
            "thumbnail_url": "https://i.ytimg.com/vi/RhlG6cXmk8A/hqdefault.jpg",
            "selection_reasoning": "This segment covers crucial concepts on preventing and escaping the north-south choke, a fundamental threat both offensively and defensively in this position. It includes both transitional defense (from side control) and late-stage escapes. By learning how to block hips, time your shrimp, and turn escapes into offense (like a single leg), students develop a more complete defensive awareness, which is the core theme of this chapter. For those who struggle to finish, understanding these escapes means you can troubleshoot why your top control or submissions fail—closing gaps in both your attack and defense.",
            "segments": [
              {
                "start_time": "0:00",
                "end_time": "1:12",
                "duration_seconds": 72,
                "title": "Hip Block Defense",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "1:12",
                "end_time": "2:24",
                "duration_seconds": 72,
                "title": "Shrimp Timing",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "2:24",
                "end_time": "3:36",
                "duration_seconds": 72,
                "title": "Turn Escape Drill",
                "reasoning": "Essential content for skill development",
                "included": true
              },
              {
                "start_time": "3:36",
                "end_time": "4:48",
                "duration_seconds": 72,
                "title": "Single Leg Transition",
                "reasoning": "Essential content for skill development",
                "included": true
              }
            ],
            "matched_questions": [
              2,
              4,
              6
            ],
            "question_texts": [
              "Basic transitions from side control to north-south position with retention tips",
              "Troubleshooting common north-south choke problems at beginner level",
              "Breaking defensive frames and grips when attacking from north-south"
            ]
          }
        ]
      }
    ]
  }
};
}
